import { useCollection } from '@/composables/useDataTableProps';
import { BusinessType, BusinessTypeCollection } from '@/models/BusinessType';

const collection = new BusinessTypeCollection();
const reactiveData = useCollection<BusinessTypeCollection, BusinessType>(collection, { pageSize: -1 });
let loadingPromise: Promise<BusinessTypeCollection> | null = null;

export function useBusinessTypes() {
    if (reactiveData.collection.length() === 0) {
        reactiveData.collection.setQueryParams({ filter: [{ id: 'type', property: 'type', value: 'pg' }] });
        loadingPromise = reactiveData.collection.query();
    }
    return {
        collection: reactiveData.collection,
        loading: loadingPromise
    };
}
